import {IntermediatePart} from "../../intermediatePart";
import {Vanity} from "../../parts/vanity";

import {LayoutType} from "../../constants";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {
  custom30in15X4Shower,
  custom30in30X8Shower,
  custom30inPonyShower,
  custom60in15X4Shower,
  custom60in30X8Shower,
  custom60inPonyShower
} from "../../../../bvComponent/core/assets";

export default class ShowerBody extends IntermediatePart {

  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partId = 'shower_body';
    this.partName = 'Shower Body';
    this.translateId = "visualizer.bathroom.shower.shower_body";
    this.homePageTitle = 'Shower Doors & Glass';
    this.partNumber = partNumber;
    this.activeFeatureParts = [];
    this.canBeDisabled = false;
    this.placeholderChanged = true; // never show placeholder to body
    this.firstClick = {
      "0": true // never show placeholder to body
    }
    this.layerPriority = 1;
    this.createdManually = true;
  }

  load(dbFeature) {
    const loadedShowerBody = super.load_(dbFeature, new ShowerBody());
    if (loadedShowerBody) { // it can be false (just skip it)
      const featureName = loadedShowerBody.dbFeature.sharedFeatureName;
      loadedShowerBody.featureName = featureName;
      loadedShowerBody.showerBodyType = 'Custom';
      loadedShowerBody.showerDimensions = this.loadShowerDimensions(featureName);
      loadedShowerBody.metaData = this.loadShowerMetaData(featureName, loadedShowerBody.showerDimensions);
      loadedShowerBody.showerBodyId = featureName.toLowerCase().replace(/ /gi, "-");
      loadedShowerBody.notAvailableInVisualizer = false;
      if (!loadedShowerBody.dbFeature.thumbnailUrl) {
        loadedShowerBody.customThumbnail = this.loadThumbnail(featureName)
      }
    }
    return loadedShowerBody
  }

  loadShowerDimensions(featureName = this.activeFeature.featureName) {
    switch (true) {
      case featureName.includes("15X4"):
        return "15X4"
      case featureName.includes("Pony"):
        return "Pony"
      case featureName.includes("30X8"):
      default:
        return "30X8"
    }
  }

  loadShowerMetaData(featureName = this.activeFeature.featureName, showerDimensions) {
    const featureNameSplitted = featureName.split("in")[0];
    return {
      "ShowerSize": featureNameSplitted.length > 1 ? [featureNameSplitted.substr(featureNameSplitted.length - 2)] : ['60'],
      "CountertopSize": showerDimensions === "30X8" ? ["72in"] : ["20in", "24in", "30in", "36in", "48in", "60in"]
    }
  }

  loadThumbnail(featureName = this.activeFeature.featureName) {
    switch (true) {
      case featureName.includes("15X4"):
        return featureName.includes("30in") ? custom30in15X4Shower : custom60in15X4Shower
      case featureName.includes("Pony"):
        return featureName.includes("30in") ? custom30inPonyShower : custom60inPonyShower
      case featureName.includes("30X8"):
      default:
        return featureName.includes("30in") ? custom30in30X8Shower : custom60in30X8Shower
    }
  }

  handleClick() {
    const parent = this.getParent();
    if (parent.getParent && parent.getParent()) {
      super.handleClick();
      parent.activeFeatureParts = parent.setActiveFeatureParts();
    } else {
      parent.showerBody.activeFeature = this;
    }
    this.getParent().showerBodySelectedByUser = true;
    const shower = this.getParent().layout ? this.getParent() : this.getParent().getParent(); // workaround for complete & custom click
    if (shower.showerTubComboIsActive) {
      const comboPart = shower.layout.parts[ShowerTubCombo.id];
      comboPart.showerTubComboIsActive = false;
    }
    this.featureClicked();
  }

  disabledClick() {
    const showerParent = this.getParent();
    showerParent.relatedItems.forEach((relItem) => {
      relItem.disabled = this.disabled;
      if (relItem.activeFeatureParts && relItem.activeFeatureParts.length) {
        relItem.activeFeatureParts.forEach((activeFeaturePart) => {
          if (activeFeaturePart) {
            activeFeaturePart.disabled = this.disabled
          }
        });
      }
    });
    if (showerParent.layout && showerParent.showerTubComboIsActive) {
      const comboPart = showerParent.layout.parts[ShowerTubCombo.id];
      comboPart.showerTubComboIsActive = false;
    }
    this.activeFeatureParts.forEach((activeFeaturePart) => {
      activeFeaturePart.disabled = this.disabled
    });
    const wallParent = showerParent.layout.parts.Walls;
    wallParent.wallExL.disabled = this.disabled;
    // wallParent.wallExR.disabled = this.disabled;

    const bathtubParent = showerParent.layout.parts.Bathtub;

    if (showerParent.layout.type === LayoutType.Small && !this.disabled && bathtubParent) {   // switch off all bathtub features
      if (bathtubParent.bathTubBody) {
        bathtubParent.bathTubBody.disabled = true;
      }
      if (bathtubParent.bathTubBody) {
        bathtubParent.bathTubBase.disabled = true;
        bathtubParent.bathTubBase.disabledClick();
      }
    }
  }

  availableFeatures(filters) {
    const layout = this.getParent().layout;
    const filteredAvailableFeatures = filters ? super.getFilteredFeaturesByFilters(filters) : this.features;
    const counterTopSize = layout.parts[Vanity.id].counterTopSize();
    return filteredAvailableFeatures.filter((feature) => {
      if (counterTopSize === '72in' && layout.type === 1) {
        return feature.showerDimensions === "30X8" || feature.showerDimensions === "Pony"
      }
      return true
    })
  }

  getArrayOfConditions() {
    return []
  }

  setActiveFeatureParts() {
    const activeFeatureParts = (this.activeFeature && this.activeFeature.partNumber) ? this.featuresParts.filter((feature) => {
      return feature.partName === this.activeFeature.partName
    }) : [];
    activeFeatureParts.forEach((activeFeaturePart) => {
      activeFeaturePart.disabled = this.disabled
    });
    return activeFeatureParts
  }

  setDefault() {
    const availableFeatures = this.availableFeatures();
    const layout = this.getParent().layout;
    let hardCodedDefault = availableFeatures.find((feature) => {
      return feature.partName === "Custom B 60in 15X4";
    });
    const counterTopSize = layout.parts[Vanity.id].counterTopSize();
    if (counterTopSize === '72in' && layout.type === 1 && this.activeFeature) {
      hardCodedDefault = availableFeatures.find((feature) => {
        return this.activeFeature.partName.includes("60in")
          ? feature.partName.includes("60in")
          : feature.partName.includes("30in")
      });
    }
    this.activeFeature = hardCodedDefault || availableFeatures[0];
    this.activeFeatureParts = this.setActiveFeatureParts();
  }

  setLayers(layout) {
    if (this.getParent().showerTubComboIsActive()) {
      super.hideLayers();
      return;
    }
    super.setLayers(layout);
  }

  setZIndex() {}

  changeLayout(layoutType) {
    if (layoutType === 1 && this.disabled) {
      this.disabled = false;
      this.disabledClick();
    }
  }
}
